import { gql } from "lib/apolloClient";

export const getAIConversationsQuery = gql`
  query getAiConverstion($id: ID!) {
    node(id: $id, type: AI_CONVERSATION) {
      ... on AiConversation {
        id
        messages {
          totalCount
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
`;
